import { requestSilent } from './utils';

export async function revokeSfAccessToken(token: string, delay: number = 0): Promise<void> {
  await requestSilent('POST', '/debug/sf-revoke-access', { delay }, token);
}
